import {useAxios} from "@/utils/useAxios";
import moment from "moment/moment";

const claimApi = {
    // [018] 보험사조회
    async getInsuranceList(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getInsuCompanies", {method: 'POST',}, {
            immediate: false,
            onSuccess: (response) => {
                data.value = response;
            },
        })
        await execute(params);
        return data;
    },

    // [023] 진료내역 조회
    async getPatientTreatment(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/gw/getPatientTreatment", {}, {
            exceptionThrow: true,
            loading: true
        })
        await execute(params);
        return data;
    },

    // [118] 위임자 진료내역 조회
    async getDeputyPatientTreatment(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/gw/getDeputyPatientTreatment", {}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data;
    },

    // [117] 자녀 진료내역 조회
    async getChildPatientTreatment(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/gw/getChildPatientTreatment", {}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data;
    },

    // [025] 실손 의료보험 계약 조회(신정원)
    async getInsuContracts(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getInsuContracts", {}, {
            loading: true,
            exceptionThrow: true,
        })
        await execute(params);
        return data;
    },

    // [025] 실손 의료보험 계약 조회v2(신정원)
    async getInsuContractsV2(params) {
        const {data, execute} = await useAxios("/cmm/api/v2/claim/getInsuContracts", {}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data;
    },

    // [025] 실손 의료보험 계약 조회v3(신정원, 대리청구)
    async getInsuContractsV3(params) {
        const {data, execute} = await useAxios("/cmm/api/v3/claim/getInsuContracts", {}, {
            loading: true,
            exceptionThrow: true,
        })
        await execute(params);
        return data;
    },

    // [025] 실손 의료보험 계약 조회v4(신정원, 자녀청구)
    async getInsuContractsV4(params) {
        const {data, execute} = await useAxios("/cmm/api/v4/claim/getInsuContracts", {}, {
            loading: true,
            exceptionThrow: true,
        })
        await execute(params);
        return data;
    },

    // [025] 실손 의료보험 계약 조회(신정원)
    async getInsuContractsDummy(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getInsuContracts/dummy")
        await execute(params);
        return data;
    },

    // [026] 회원청구정보 조회
    async getMyClaimInfo(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getMyClaimInfo", {method: 'POST',}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data;
    },

    // [031] 실손보험 본인청구
    async genSelfClaim(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/genSelfClaim", {method: 'POST',}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data;
    },

    // [032] 대리청구 청구서 작성
    async genDeputyClaim(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/genDeputyClaim", {method: 'POST',}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data;
    },

    // [048] 사용자 약관 동의하기
    async setTermsAgree(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/base/setTermsAgree", {method: 'POST',}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data.value;
    },

    // [062] 위임관리 목록
    async getDeputyClaimTargetMember(params) {
        const {
            data,
            result,
            execute
        } = await useAxios("/cmm/api/v1/usr/getDeputyClaimTargetMember", {method: 'POST',}, {
            immediate: false,
            onSuccess: (response) => {
                data.value = response;
            },
        })
        await execute(params);
        return data.value;
    },

    // [066] 위임동의 요청
    async genDelegateApproval(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/genDelegateApproval", {method: 'POST',},
            {
                exceptionThrow: true
            }
        )
        await execute(params);
        return data;
    },

    // [067] 위임동의 요청 철회
    async delDelegateApproval(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/delDelegateApproval", {method: 'POST',}, {
            immediate: false,
            onSuccess: (response) => {
                data.value = response;
            }
        })
        await execute(params);
        return data;
    },

    // [068] 위임동의
    async setDelegateApproval(params) {
        const {data, execute} = await useAxios("/cmm/api/v2/claim/setDelegateApproval", {}, {
            exceptionThrow: true
        })
        await execute(params);
        return data;
    },

    // [068] 위임동의 테스트
    async setDelegateApprovalTest(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/setDelegateApproval/test", {}, {
            exceptionThrow: true
        })
        await execute(params);
        return data;
    },

    // [069] 위임동의 거절
    async setDelegateRejection(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/setDelegateRejection")
        await execute(params);
        return data;
    },

    // [070] 대리청구 상태 조회
    async getDeputyClaimStatus(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getDeputyClaimStatus", {}, {
            exceptionThrow: true
        })
        await execute(params);
        return data;
    },

    // [137] 공공데이터_가족관계증명서
    async getMyDataFamily(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/gw/getMyDataFamily", {}, {
            loading: true,
            exceptionThrow: true
        })
        await execute(params);
        return data;
    },

    // [003] SCI 실명인증
    async request(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/sci/name/request", {}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data;
    },

    // [137] 자녀 공공데이터_가족관계증명서 연동 조회
    async getMemberChildExist(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/getMemberChildExist", {}, {
            loading: true,
            exceptionThrow: true
        })
        await execute(params);
        return data;
    },

    // [071] 자녀 조회
    async getMemberChild(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/usr/getMemberChild", {}, {
            loading: true,
            exceptionThrow: true
        })
        await execute(params);
        return data;
    },

    // [074] 기관 업무중단 일정 조회
    async getBreakSchedules(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getBreakSchedules")
        await execute(params);
        return data;
    },

    // [074] 기관 업무중단 일정 조회
    async getIncoBreakSchedules(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getIncoBreakSchedules", {method: 'POST',}, {
            loading: true,
            exceptionThrow: false,
        })
        await execute(params);
        return data;
    },

    // [074] 병원 업무중단 일정 조회
    async getHospitalBreakSchedules(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getHospitalBreakSchedules", {method: 'POST',}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data;
    },

    // [077] 대리청구 이어서 진행
    async setDeputyClaim(params) {
        const {data, execute} = await useAxios("/cmm/api/v2/claim/setDeputyClaim", {method: 'POST',}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data.value.result;
    },

    // [078] 자녀청구
    async genChildClaim(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/genChildClaim", {method: 'POST',}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data;
    },

    // [094] 위임인 정보 조회
    async getDeputyClaimTargetMemberAlarm(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getDeputyClaimTargetMember", {method: 'POST',}, {
            immediate: false,
            exceptionThrow: true,
            onSuccess: (response) => {
                data.value = response;
            }
        })
        await execute(params);
        return data.value;
    },

    // [095] 위임동의 약관 조회
    async getDelegateApprovalTerms(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getDelegateApprovalTerms", {}, {
            exceptionThrow: true
        })
        await execute(params);
        return data;
    },

    // [999] 위임동의 알림톡 재발송
    async setDelegateApprovalSend(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/setDelegateApprovalSend")
        await execute(params);
        return data;
    },

    // [999] 대리청구 취소
    async setDeputyCancel(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/setDeputyCancel", {}, {
            exceptionThrow: true
        })
        await execute(params);
        return data;
    },

    // [109] 대리청구 청구키 유효성 조회
    async getDeputyClaimValidCheck(params) {
        let errValue = null;
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getDeputyClaimValidCheck", {}, {
            onSuccess: (response) => {

            },
            onError: (err) => {
                errValue = err;
            }
        })
        await execute(params);
        if (errValue) {
            return Promise.reject(errValue);
        } else {
            return data;
        }
    },

    // [108] 대리청구 보험사 약관조회
    async getDeputyClaimTerms(params) {
        let errValue = null;
        const {data, execute} = await useAxios("/cmm/api/v2/claim/getDeputyClaimTerms", {}, {
            onSuccess: (response) => {

            },
            onError: (err) => {
                errValue = err;
            }
        })
        await execute(params);
        if (errValue) {
            return Promise.reject(errValue);
        } else {
            return data;
        }
    },

    // [111] 대리청구 취소
    async setCancelDeputyClaim(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/setCancelDeputyClaim",
            {method: 'POST'},
            {
                immediate: false,
                onSuccess: (response) => {
                    data.value = response;
                }
            })
        await execute(params);
        return data;
    },

    // [999] 대리청구 위임요청자 정보 조회
    async getDeputyClaimMember(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getDeputyClaimMember")
        await execute(params);
        return data.value.result;
    },

    // [070] 대리청구 내용 조회
    async getDeputyClaimContent(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/getDeputyClaimContent")
        await execute(params);
        return data.value.result;
    },

    // [133] 레포트생성 Viewer용
    async genReportViewer(params) {
        let url = '';
        if(params.taskTypeCd == '01'){
            url = "/cmm/api/v1/cmm/genViewReport"
        }else{
            url = "/cmm/api/v1/cmm/genOtherViewReport"
        }
        const {data, error, execute} = await useAxios(url)
        await execute(params);

        // api 호출후 에러발생할경우 에러 출력
        if (error.value) {
            throw new Error(error.value.response.data.failureMessage.exceptionMessage);
        }

        // isValid값이 true인경우 viewer 실행
        if (data.value.isValid) {

            try {
                const hostname = window.location.hostname;
                let url = '';
                if (hostname.includes('tsilson24.or.kr')) {
                    //'https://rpt.tsilson24.or.kr/ubi4/ubihtml_n.jsp';
                    url = 'https://rpt.tsilson24.or.kr/ubi4/ubihtml_n.jsp';
                } else if (hostname.includes('silson24.or.kr')) {
                    url = process.env.VUE_APP_VIEWER_RUL
                } else {
                    url = 'http://192.168.28.143:18082/ubi4/ubihtml_n.jsp';
                }

                const obj = {tmpltFileNm: data.value.tmpltFileNm, fileNm: data.value.fileNm}
                const params = {
                    tmpltFileNm: obj.tmpltFileNm,
                    fileNm: obj.fileNm
                }

                const form = document.createElement('form');
                form.method = 'POST';
                form.action = url;
                form.target = '_blank';

                for (const key in params) {
                    if (params.hasOwnProperty(key)) {
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = key;
                        input.value = params[key];
                        form.appendChild(input);
                    }
                }

                document.body.appendChild(form);
                form.submit();
            } catch (error) {
                throw new Error('레포트뷰어를 실행하는도중 에러가 발생하였습니다.');
            }

        } else {
            throw new Error(data.value.tmpltFileNm);
        }
    },

    // [100] 레포트 생성(진료내역 서류조회)
    async genReport(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/cmm/genReport",
            {method: 'POST', responseType: 'arraybuffer'},
            {
                immediate: false,
                exceptionThrow: true,
                onSuccess: (response) => {
                    const blob = new Blob([response.data], {type: "application/pdf"});
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");

                    a.style.display = "none";
                    a.href = url;
                    a.download = moment().format('YYYYMMDDHHSS');
                    document.body.appendChild(a);
                    a.click();

                    //메모리제거
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                }
            })
        await execute(params);
        return data;
    },

    // [038] 내 청구내역 보기
    async getInsuClaims(params) {
        const {data, execute} = await useAxios("/cmm/api/v2/usr/getInsuClaims", {method: 'POST'}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data.value.result;
    },

    // [038] 내 자녀청구내역 보기
    async getChildInsuClaims(params) {
        const {data, execute} = await useAxios("/cmm/api/v3/usr/getInsuClaims", {method: 'POST'}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data.value.result;
    },

    // [033] 실손보험 추가청구
    async genAdditionalClaim(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/genAdditionalClaim", {method: 'POST'}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data;
    },

    // [078] 실손보험 추가청구
    async genAdditionalChildClaim(params) {
        const {data, execute} = await useAxios("/cmm/api/v1/claim/genAdditionalChildClaim", {method: 'POST'}, {
            exceptionThrow: true,
        })
        await execute(params);
        return data;
    },

    // [999] 실손청구 첨부파일 악성코드 검사
    // async setClaimFileCheck(params) {
    //     const {data, execute} = await useAxios("/cmm/api/v1/claim/setClaimFileCheck",
    //     {
    //         method: 'POST'
    //     }, {
    //
    //         loading: true,
    //         exceptionThrow: true,
    //     })
    //     await execute(params);
    //     return data;
    // },

}

export default claimApi;
